import { render, staticRenderFns } from "./CooptationPage.vue?vue&type=template&id=453b503b&"
import script from "./CooptationPage.vue?vue&type=script&lang=js&"
export * from "./CooptationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports